import ColumnIcon from "@material-ui/icons/ViewColumn";
import React from "react";
import T from "prop-types";
import { useTranslate } from "react-admin";

import { CheckboxGroupDrawer } from "../CheckboxGroupDrawer";
import { useSimpleModal } from "../useSimpleModal";
import { ToolbarButton } from "./ToolbarButton";

export const ExportColumnsButton = ({ choices, value, onChange }) => {
	const columnsModal = useSimpleModal();
	const translate = useTranslate();
	const title = translate("osfc.buttons.columns");

	const onClose = (selected) => {
		onChange(selected);
		columnsModal.handleClose();
	};

	return (
		<React.Fragment>
			<ToolbarButton onClick={columnsModal.handleOpen} icon={<ColumnIcon />}>
				{title}
			</ToolbarButton>
			{columnsModal.opened && (
				<CheckboxGroupDrawer choices={choices} value={value} title={title} onClose={onClose} />
			)}
		</React.Fragment>
	);
};

ExportColumnsButton.propTypes = {
	choices: T.arrayOf(T.object).isRequired,
	value: T.array.isRequired,
	onChange: T.func.isRequired,
};
